// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Loader_spinner__cP0AD","spinnerSector":"Loader_spinnerSector__3Wcu5","rotate":"Loader_rotate__aH8wC"};